module.exports = __webpack_public_path__ + "img/image_slide3_1.5ccd9eea.png";